module.exports = __webpack_public_path__ + "img/web_morse_3.8f9a90e2.jpg";